import { useState, useEffect } from "react";
import Button from "../../Components/Buttons/Button"
import { useNavigate, useLocation } from "react-router-dom";
import { useModal } from "../../Components/Modal";
import RoleGuard from "../../Components/RoleGuard";
import Footer from "../../Components/Footer"
import WorkspaceSelector from "../../Helper/WorkspaceSelector";
import WorkspaceCreation from "../Dashboard/WorkspaceCreation";
import ScrollWrapper from "../../Components/ScrollWrapper";
import { useWebSocket } from "../../Context/WebSocketContext";
import PeerConnection from "../Dashboard/PeerConnection";
import { getWorkspace } from "../../Model/Workspace";
import { workspaceEvents } from "../../db/workspaceEvents";

const Sidebar = () => {
    const { ModalView, openModal } = useModal()
    const { checkForExisting } = WorkspaceSelector()

    const [workspace, setWorkspace] = useState(null)
    useEffect(() => {
        async function loadWorkspace() {
            const data = await getWorkspace()
            setWorkspace(data)
        }
        loadWorkspace();

        const handleWorkspaceChange = () => {
            loadWorkspace();
        };

        workspaceEvents.addEventListener("workspaceChange", handleWorkspaceChange);

        return () => {
            workspaceEvents.removeEventListener("workspaceChange", handleWorkspaceChange);
        };
    }, [])

    const subscription = workspace?.subscription;
    const isTester = workspace?.freeTester;
    const navigate = useNavigate();
    const location = useLocation()
    const [isCollapsed, setIsCollapsed] = useState(
        localStorage.getItem('sidebarCollapsed') === 'true'
    );
    const { isOnline } = useWebSocket();

    const handleRedirect = (route) => {
        navigate(`/app${route}`);
    };

    function isAllowed(target) {
        return (subscription && subscription[target] ) || isTester
    }

    const toggleSidebar = () => {
        const newState = !isCollapsed;
        localStorage.setItem('sidebarCollapsed', newState);
        setIsCollapsed(newState);
    };

    const sidebarRenderItem = ({
        tablerName,
        text,
        path,
        isPath = true,
        modal = null
    }) => {
        const fullPath = `/app${path}`;
        const isActive = location.pathname === fullPath && path !== "";

        return (
            <Button
                classNames="w-full h-fit gap-1 p-3"
                itemPosition="justify-start items-center"
                borderStyle="rounded-lg"
                buttonColor={
                    isActive
                        ? "bg-[#e9eef7]"
                        : "bg-white hover:bg-[#e9eef7]"
                }
                onClickAction={() =>
                    isPath ? handleRedirect(path) : openModal(modal)
                }
                text={text}
                textClasses={isCollapsed ? "hidden" : ""}
                tIconName={tablerName}
            />
        );
    };

    const sidebarElement = ({ tablerName, text, path, requireWorkspace = false, disableOffline = false, isPath = true, modal = null }) => {
        return (disableOffline && !isOnline ? (null) : (requireWorkspace ? (checkForExisting() ? (sidebarRenderItem({ tablerName: tablerName, text: text, path: path, isPath: isPath, modal: modal })) : (null)) : (sidebarRenderItem({ tablerName: tablerName, text: text, path: path, isPath: isPath, modal: modal }))))
    }

    return (
        <div
            className={`h-full flex flex-col border-r border-gray-200 pb-1 transition-all duration-300 ease-in-out ${isCollapsed ? "w-16" : "w-64"}`}
        >
            <Button
                classNames="w-fit h-fit p-3"
                tIconName={"menu-2"}
                borderStyle=""
                buttonColor="bg-white"
                onClickAction={toggleSidebar}
            />
            <div className="h-full w-fit flex flex-col border-t border-gray-200 overflow-y-hidden" id="sidebar-wrapper">
                <ScrollWrapper>
                    <div className="h-full w-fit flex flex-col items-center px-2 gap-1 pt-1">
                        {sidebarElement({ tablerName: "home", text: "Home", path: "/" })}
                        <RoleGuard>
                            {sidebarElement({ tablerName: "chart-donut", text: "Statistiken", path: "/statistics", requireWorkspace: true })}
                            {(isAllowed("allowCashierUserTracking") && workspace?.cashierUserTracking) && sidebarElement({ tablerName: "invoice", text: "Kassenzählung", path: "/cash_accounting", requireWorkspace: true })}
                            {(isAllowed("useInventoryManagement")) && sidebarElement({ tablerName: "building-warehouse", text: "Inventar", path: "/inventory", requireWorkspace: true })}
                            {sidebarElement({ tablerName: "settings", text: "Einstellungen", path: "/settings", requireWorkspace: true, disableOffline: true })}
                        </RoleGuard>
                        <div className="w-full border-t border-gray-200 mx-3" />
                        {/* {sidebarElement({ tablerName: "help", text: "Hilfe", path: "/help" })} */}
                        {sidebarElement({ tablerName: "plus", text: "Workspace", path: "", requireWorkspace: true, disableOffline: true, isPath: false, modal: <WorkspaceCreation /> })}
                        {(isAllowed("useLocalConnection")) && sidebarElement({ tablerName: "line", text: "Verbinden", path: "", requireWorkspace: false, disableOffline: false, isPath: false, modal: <PeerConnection /> })}
                        <RoleGuard specificRole={"ADMIN"}>
                            {sidebarElement({ tablerName: "code", text: "Admin Panel", path: "/admin_panel", disableOffline: true })}
                        </RoleGuard>
                    </div>
                </ScrollWrapper>
            </div>
            <ModalView classNames="w-fit h-fit" />
            {!isCollapsed && <Footer />}
        </div>
    )
}
export default Sidebar